import { SmartphotoField } from './fields/smartphoto-field.class';
var FieldCategory;
(function (FieldCategory) {
    FieldCategory["Creation"] = "creation";
    FieldCategory["Closing"] = "closing";
    FieldCategory["Cancellation"] = "cancellation";
    FieldCategory["Smartphoto"] = "smartphoto";
})(FieldCategory || (FieldCategory = {}));
export class SmartphotoCompanyFields {
    currentSelectors;
    fieldDescriptions = {
        cancellationFields: [
            {
                fieldDescription: 'comments',
                dataType: 'textarea',
                fieldName: 'comments',
                mandatory: false,
                placeholder: 'comments_cancellation_help'
            }
        ],
        closingFields: [
            {
                fieldDescription: 'over_excess',
                dataType: 'radio',
                fieldName: 'over_excess',
                listName: 'over_excess',
                mandatory: true
            },
            {
                fieldDescription: 'comments_review',
                dataType: 'textarea',
                fieldName: 'comments',
                mandatory: false,
                placeholder: 'comments_help'
            }
        ],
        createFields: [],
        selfAdjustFields: []
    };
    closing = [];
    cancellation = [];
    creation = [];
    smartphoto = [];
    constructor(smartphoto, fieldDescriptions, selectors) {
        this.currentSelectors = selectors;
        this.setup(fieldDescriptions);
        this.generateFields(smartphoto);
    }
    setup(fieldDescriptions) {
        if (!Object.keys(this.currentSelectors).includes('over_excess')) {
            this.currentSelectors.over_excess = [
                { name: 'no_excessed', value: 0, order: 0 },
                { name: 'excessed', value: 1, order: 1 },
                { name: 'insufficient_information', value: 2, order: 2 }
            ];
        }
        Object.keys(this.fieldDescriptions).forEach((fieldsKey) => {
            const key = fieldsKey;
            if (fieldDescriptions[key].length) {
                this.fieldDescriptions[key] = fieldDescriptions[key];
            }
        });
    }
    generateFields(smartphoto) {
        const fieldCategoryMap = {
            selfAdjustFields: FieldCategory.Smartphoto,
            createFields: FieldCategory.Creation,
            cancellationFields: FieldCategory.Cancellation,
            closingFields: FieldCategory.Closing
        };
        Object.keys(fieldCategoryMap).forEach((fieldDescriptionKey) => {
            const mapKey = fieldDescriptionKey;
            const fieldDescriptions = this.fieldDescriptions[mapKey];
            const category = fieldCategoryMap[mapKey];
            this[category] = fieldDescriptions.map((companyField) => {
                return new SmartphotoField({ ...companyField, custom: true }, smartphoto, this.currentSelectors);
            });
        });
    }
}
